import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import FeedHeader from './FeedHeader'
import { setTab, fetchLeaderBoard, setFilterByTeam, storiesUnreadCount } from 'store/entities/feed/actions'
import {
  getFeedTab,
  getFeedFilterByTeam,
  getFeedFilterByRange,
  getFeedUnreadStoriesCount,
} from 'store/entities/feed/selectors'
import {
  getIdentityTeams,
  isOrganizationHasStories,
  getIdentityOrganizationTeamOnly,
} from 'store/entities/identity/selectors'
import withDidMountRequest from 'app/connectors/withDidMountRequest'

const mapStateToProps = createStructuredSelector({
  tab: getFeedTab,
  teams: getIdentityTeams,
  byTeam: getFeedFilterByTeam,
  byRange: getFeedFilterByRange,
  isOrganizationHasStories: isOrganizationHasStories,
  isTeamOnly: getIdentityOrganizationTeamOnly,
  showUnreadCounter: getFeedUnreadStoriesCount,
})

const mapDispatchToProps = {
  setTab,
  fetchLeaderBoard,
  setFilterByTeam,
  onRequest: storiesUnreadCount.get.request,
}

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(withTranslation('user')(FeedHeader)))
